import { type ProjectCode } from '@constants'
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

export const CAMPAIGN_PRODUCTS_STORAGE_KEY = 'fpCampaignProductsStorage'

interface FpCampaignProductsState {
  projectCode: ProjectCode | null
  setProjectCode: (projectCode: ProjectCode | null) => void
}

export const useFpCampaignProductsStore = create<FpCampaignProductsState>()(
  persist(
    set => ({
      projectCode: null,
      setProjectCode: (projectCode: ProjectCode | null) => set({ projectCode }),
    }),
    {
      name: CAMPAIGN_PRODUCTS_STORAGE_KEY,
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)

const registerUpdateStore = () => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return
  // re-hydrate store
  const updateStore = () => {
    useFpCampaignProductsStore.persist.rehydrate()
  }

  document.addEventListener('visibilitychange', updateStore)
  window.addEventListener('focus', updateStore)
}
registerUpdateStore()
